import * as React from 'react';
import { SavedSurveyItem, SurveyItemType } from 'client/shared/core/question';
import {
  FeedCardBanner,
  FeedCardBannerProps,
} from 'client/respondent/feed/components/body/feed-card/feed-card-banner';
import { setTypeToBadge } from 'client/respondent/graphql-util/transform/badge';
import { getLabelForSetType } from 'client/shared/core/question-set';
import Grid from '@mui/material/Grid2';
import { Typography } from '@mui/material';
import { HtmlContent } from 'client/shared/components/base';

export interface SurveyRowProps {
  readonly row: Extract<SavedSurveyItem, { readonly type: SurveyItemType.ROW }>;
}

export const SurveyRow: React.FC<SurveyRowProps> = (p) => {
  return (
    <>
      {p.row.data.label && (
        <Typography py="1.5rem" variant="h2">
          <HtmlContent html={p.row.data.label} />
        </Typography>
      )}
      <Grid
        container
        spacing={4}
        sx={{
          justifyContent: 'space-end',
        }}
      >
        {p.row.data.content.map((content) => {
          const key = `${content.contentId}-${content.type}`;
          const feedCardProps: FeedCardBannerProps = {
            postImage: content.imageUrl,
            postTitle: content.name,
            shortDescription: content.shortDescription,
            badges: [setTypeToBadge(content.type, content.featureSet)],
            primaryAction: {
              key: `${key}-primary-action`,
              content: {
                type: 'LABEL',
                label: `View ${getLabelForSetType(
                  content.type,
                  content.featureSet,
                  content.isPrioritize
                )}`,
              },
              action: {
                type: 'LINK',
                url: content.url,
              },
            },
            bottomActions: [],
            singleQuestion: false,
            isPinnedToPublisher: false,
            key,
          };
          return (
            <Grid
              key={`${key}-grid`}
              size={{ xs: 12, md: Math.floor(12 / p.row.data.numColumns) }}
            >
              <FeedCardBanner {...feedCardProps} />
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};
